// extracted by mini-css-extract-plugin
export default {"GUINav":"GameNav_GUINav__7gAXl","livesWrapper":"GameNav_livesWrapper__TRsOA"};